import React from 'react';

import styles from './index.module.scss';
import { Field } from '../index';

type Props = {
  disabled?: boolean;
  /**
   * Field label.
   */
  label?: string;
  /**
   * Field name.
   */
  name: string;
};

const ToggleCheckboxField = ({ label = '', name, ...props }: Props) => {
  return (
    <div className={styles['toggle-checkbox-field']}>
      <label
        htmlFor={`toggle-checkbox-${name}`}
        className={`${props?.disabled ? styles['toggle-checkbox-field--disabled'] : styles['toggle-checkbox-field--enabled']}`}
      >
        <span>{label}</span>
        <div className={styles['toggle-checkbox-field__root']}>
          <Field
            name={name}
            id={`toggle-checkbox-${name}`}
            component="input"
            type="checkbox"
            aria-label={label}
            data-component={'toggle-checkbox-field'}
            {...props}
          />
          <span className={styles['toggle-checkbox-field__slider']}></span>
        </div>
      </label>
    </div>
  );
};

export default ToggleCheckboxField;
